// The dealer website themes on /dealer-websites. Ids match server/sitepreviews (Themes), which
// serves each one's live preview; the colors are each theme's default palette, so the card looks
// like the site it opens.
export const THEMES = [
    {
        id: 'showa',
        name: 'Shōwa Showroom',
        fit: 'Kei trucks & vans',
        line: 'A warm 1970s showroom: round badges, a mustard band and big friendly type.',
        headline: 'Small trucks. Big personality.',
        colors: {
            ground: '#F1E8D6',
            ink: '#1C1A17',
            accent: '#D2412C',
            accent2: '#E9B53A'
        }
    },
    {
        id: 'aizome',
        name: 'Aizome',
        fit: 'Collector cars',
        line: 'Indigo, washi and a hanko red. Quiet and upmarket, for cars sold by provenance.',
        headline: 'Japan’s finest, chosen slowly.',
        colors: {
            ground: '#F6F4EF',
            ink: '#16181D',
            accent: '#1F3A68',
            accent2: '#B3261E'
        }
    },
    {
        id: 'yoru',
        name: 'Yoru',
        fit: 'JDM performance',
        line: 'Night street in neon pink and cyan, with a chassis search right in the hero.',
        headline: 'Right-hand drive. After dark.',
        colors: {
            ground: '#0C0C12',
            ink: '#F4EFE4',
            accent: '#FF3D8B',
            accent2: '#2DE2E6'
        }
    },
    {
        id: 'motor-court',
        name: 'Motor Court',
        fit: 'Independent lots',
        line: 'A family-run lot under a roadside sign. Honest, warm and easy to trust.',
        headline: 'Good cars. Honest deals.',
        colors: {
            ground: '#F4EAD5',
            ink: '#2B1D14',
            accent: '#B8461B',
            accent2: '#16706F'
        }
    },
    {
        id: 'window-sticker',
        name: 'Window Sticker',
        fit: 'Price-forward lots',
        line: 'Every listing reads like a window sticker, out-the-door price included.',
        headline: 'Every price. Every fee. On the window.',
        colors: {
            ground: '#FFFFFF',
            ink: '#111111',
            accent: '#0B4F8A',
            accent2: '#E6EEF6'
        }
    }
];
/** What every site includes, in the order the page lists it. */ export const INCLUDED = [
    {
        k: '壱 · Hosted',
        title: 'We host it and keep it running',
        text: 'WordPress, hosting, security updates, backups and the SSL certificate are on us. You never log in to a server.'
    },
    {
        k: '弐 · Synced',
        title: 'Inventory goes out on its own',
        text: 'Cars you list in Right Hand DMS go up with their photos, specs and translated auction sheet. When a car sells or goes on hold, the site shows it.'
    },
    {
        k: '参 · Both ways',
        title: 'Leads and deposits come back in',
        text: 'Enquiries, car searches and deposits from the site land in Right Hand DMS as customers, tied to the car they asked about.'
    },
    {
        k: '四 · Deposits',
        title: 'Take deposits through your own Square',
        text: 'Hold-a-car deposits go through your own Square account, so the money goes straight to you. We never handle it.'
    },
    {
        k: '五 · Embeds',
        title: 'Your financing and other tools, embedded',
        text: 'Embed your lender’s pre-qualification form, a booking calendar or a reviews widget. If a partner gives you an iframe, we can put it on the site.'
    },
    {
        k: '六 · Your domain',
        title: 'On the domain you already own',
        text: 'We connect the site to the domain your dealership already has registered. The domain stays yours.'
    }
];
